import { render, staticRenderFns } from "./litigationArbitrationList.vue?vue&type=template&id=676afff0&scoped=true"
import script from "./litigationArbitrationList.vue?vue&type=script&lang=js"
export * from "./litigationArbitrationList.vue?vue&type=script&lang=js"
import style0 from "./litigationArbitrationList.vue?vue&type=style&index=0&id=676afff0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676afff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676afff0')) {
      api.createRecord('676afff0', component.options)
    } else {
      api.reload('676afff0', component.options)
    }
    module.hot.accept("./litigationArbitrationList.vue?vue&type=template&id=676afff0&scoped=true", function () {
      api.rerender('676afff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/credit/report/pdfDataInfo/mainCreditEvaluation/litigationArbitrationList.vue"
export default component.exports